<template>
  <div>
    <NavMenu class="left_menu"></NavMenu>
    
  </div>
</template>

<script>
import NavMenu from '../components/NavMenu.vue'

export default {
    name:'AdminPage',
    components:{NavMenu}
}
</script>

<style>
    .left_menu{
        width: 400px;
    }
</style>